
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/26d8c27b87decb516fa51c337abf97bb.jpeg" 
              alt="ESAPCOR Logo" 
              className="h-14 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('quiz-section')}
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Trắc Nghiệm
            </button>
            <a
              href="/countdown"
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Countdown 10
            </a>
            <a
              href="/countdown-2min"
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Countdown 2
            </a>
            <a
              href="/robotics-register"
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Robotics
            </a>
            <a
              href="/personal-brand"
              className={`text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Personal Brand
            </a>
            <button
              onClick={() => scrollToSection('contact-section')}
              className="whitespace-nowrap px-6 py-2.5 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              Liên Hệ
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
